import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UiTableAction } from '../../models/ui-table.model';

@Component({
  selector: 'app-ui-table-actions',
  templateUrl: './ui-table-actions.component.html',
  styleUrls: ['./ui-table-actions.component.scss']
})
export class UiTableActionsComponent {
  @Input() actions: UiTableAction[] = [
    { type: 'view', visible: true },
    { type: 'edit', visible: true },
    { type: 'more', visible: true }
  ];
  @Output() actionClick = new EventEmitter<{ type: string; event: MouseEvent }>();

  readonly iconMap: Record<string, string> = {
    view: 'visibility',
    edit: 'edit',
    more: 'more_vert',
    delete: 'delete',
    docs: 'description',
    reopen: 'refresh',
    'cancel-approval': 'cancel',
    expand: 'keyboard_arrow_down',
    collapse: 'keyboard_arrow_up',
  };

  get visibleActions(): UiTableAction[] {
    return this.actions.filter(a => a.visible !== false);
  }

  onAction(type: string, event: MouseEvent): void {
    event.stopPropagation();
    this.actionClick.emit({ type, event });
  }
}
